Ext.define('SA.DatasetIds', {
    singleton: true,

    ACS: 'USACS',
    MRISimmonsCrosstab: 'MRISMNUSA',
    SimmonsCrosstab: 'SMNNCS',
    ScarboroughCrosstab: 'SCRBGHXTAB',
    ScarboroughNonCrosstab: 'SCRBGH',
});